<template>
  <div class="header__wrapper">
    <div class="text__wrapper">
      <h2 v-if="header.title">{{ header.title }}</h2>
      <p v-if="header.intro" class="sans__reg">{{ header.intro }}</p>
    </div>
    <!-- <side-illustration v-if="header.sideIllustration" /> -->
    <div v-if="header.illustration" class="illustration">
      <div :is="header.illustration" />
    </div>
  </div>
</template>


<script>
export default {
  name: 'simple-title',
  props: ['header'],
  components: {},
}
</script>

<style scoped lang="sass">
@import '../styleguide/index.sass'
.header__wrapper
  margin-bottom: $space-5
  display: flex
  justify-content: space-between
  align-items: center

.text__wrapper
  width: 100%
  max-width: 600px
  h2
    text-transform: uppercase

.illustration
  position: relative
  display: flex
  flex: 1 1 auto
  min-width: 80px
  width: 170px
  max-height: 100px
  overflow: hidden
  transform: translate(0, -20%) scale(1.5)
  svg
    flex: 1 1 auto


</style>



// WEBPACK FOOTER //
// src/components/headers/simple-title.vue